import { z } from "zod";

export type TrafficTierType = {
  name: string;
  amountGb: number;
  discountPct: number;
};

export const trafficTiers: TrafficTierType[] = [
  {
    name: '48 Gb',
    amountGb: 48,
    discountPct: 10,
  },
  {
    name: '96 Gb',
    amountGb: 96,
    discountPct: 20,
  },
  {
    name: '120 Gb',
    amountGb: 120,
    discountPct: 30,
  },
];

export const BYTES_PER_GB = 1024 * 1024 * 1024;

/**
 * Traffic tiers should be sorted from low to high amount of traffic
 */
const validateTiers = (trafficTiers: TrafficTierType[]) => {
  if (!trafficTiers) {
    throw new Error('Failed to validate traffic tiers');
  }
  if (!trafficTiers[0]) {
    throw new Error('Failed to validate traffic tiers');
  }
  for (let i = 1; i < trafficTiers.length; i++) {
    if (trafficTiers[i - 1].amountGb >= trafficTiers[i].amountGb) {
      console.error({ trafficTiers, i });
      throw new Error('Failed to validate traffic tiers');
    }
    if (trafficTiers[i - 1].discountPct > trafficTiers[i].discountPct) {
      throw new Error('Failed to validate traffic tiers');
    }
  }
};
validateTiers(trafficTiers);

export const findFloorTrafficTier = (trafficGb: number) => {
  for (let i = trafficTiers.length - 1; i >= 0; i--) {
    if (trafficGb >= trafficTiers[i].amountGb) {
      return trafficTiers[i];
    }
  }
  return {
    name: '',
    amountGb: 0,
    discountPct: 0,
  };
};

export const TrafficUsedZod = z.object({
  ID: z.number(),
  Name: z.string(), // subscription name
  bytes_allowed: z.number(),
  bytes_used: z.number(),
});
export type TrafficUsedType = z.infer<typeof TrafficUsedZod>;
export type AllTrafficUsedType = {
  [key: string]: TrafficUsedType;
}